import { Text, type TextProps, TextVariant } from '@vizit/atoms';

function DialogTitle(props: TextProps) {
  // The Text atom truncates to a single line by default, which cut dialog
  // titles off with an ellipsis whenever they exceeded the dialog width. A
  // dialog title must stay fully readable, so it wraps onto further lines
  // instead. Callers can still opt back into truncation via `showEllipsis`.
  return <Text variant={TextVariant.HeaderLg} elementType="h2" slot="title" showEllipsis={false} {...props} />;
}

export { DialogTitle };
